import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // ===== NAVIGATION =====
    dashboard: "Tableau de bord",
    chantiers: "Chantiers",
    materiaux: "Matériaux",
    calendrier: "Calendrier",
    assistant: "Assistant IA",
    rdv: "Rendez-vous",
    demandes: "Demandes matos",
    language: "Langue",
    logout: "Déconnexion",

    // ===== DASHBOARD =====
    dashboardTitle: "Tableau de Bord",
    dashboardSubtitle: "Vue d'ensemble de vos chantiers et ressources",
    activeChantiers: "Chantiers actifs",
    onTotal: "sur {0} total",
    materialsInStock: "Matériaux en stock",
    typesReferenced: "types référencés",
    urgentTasks: "Tâches urgentes",
    toProcess: "à traiter",
    totalBudget: "Budget total",
    allChantiers: "tous chantiers",
    recentChantiers: "Chantiers récents",
    stockAlerts: "Alertes stock",
    noChantierRegistered: "Aucun chantier enregistré",
    allStocksOk: "Tous les stocks sont OK",
    progression: "Progression",
    stock: "Stock",
    threshold: "seuil",
    todaySection: "Aujourd'hui",
    activeSites: "Chantiers actifs",
    rdvToday: "RDV à venir",
    materialsTomorrow: "Matos demain",
    pendingRequests: "Demandes en attente",
    remindersBanner: "Rappels du jour",
    rdvTodayLabel: "RDV aujourd'hui",
    rdvTomorrowLabel: "RDV demain",
    materialsToPrepare: "matériaux à préparer",
    deadlineSoon: "deadline proche",
    allReady: "Tout est prêt !",
    stockOK: "Niveaux suffisants",
    nextRDV: "Prochains RDV",
    planBtn: "Planifier",
    noRDV: "Aucun RDV à venir",
    recentSites: "Chantiers récents",
    seeAll: "Voir tout",
    createFirst: "Créer le premier",
    matsDemain: "Matériaux demain",
    actifs: "Actifs",
    urgences: "Urgences",
    budgetStat: "Budget",
    greetingMorning: "Bonjour",
    greetingAfternoon: "Bon après-midi",
    greetingEvening: "Bonsoir",

    // ===== CHANTIERS =====
    chantiersTitle: "Chantiers",
    chantiersSubtitle: "Gérez vos projets de construction",
    newChantier: "Nouveau chantier",
    searchChantier: "Rechercher un chantier...",
    noChantier: "Aucun chantier",
    noAssignedChantier: "Aucun chantier assigné",
    createFirstChantier: "Commencez par créer votre premier chantier",
    createChantier: "Créer un chantier",
    editChantier: "Modifier le chantier",
    chantierName: "Nom du chantier",
    address: "Adresse",
    client: "Client",
    startDate: "Date début",
    expectedEndDate: "Date fin prévue",
    status: "Statut",
    budget: "Budget",
    description: "Description",
    cancel: "Annuler",
    create: "Créer",
    update: "Mettre à jour",
    inProgress: "En cours",
    paused: "En pause",
    completed: "Terminé",
    confirmDeleteChantier: "Êtes-vous sûr de vouloir supprimer ce chantier ?",
    viewDetails: "Voir détails",
    chantierCount: "{0} chantier",
    chantiersCount: "{0} chantiers",
    assignedLabel: "assignés",
    totalLabel: "au total",

    // ===== CHANTIER DETAIL TABS =====
    tabInfos: "Infos",
    tabNotes: "Notes",
    tabPhotos: "Photos",
    tabEquipe: "Équipe",
    tabHistory: "Historique",

    // ===== CHANTIER DETAIL INFOS =====
    chantierClient: "Client",
    chantierBudget: "Budget",
    chantierAddress: "Adresse",
    chantierStart: "Début",
    chantierEnd: "Fin prévue",
    chantierProgress: "Progression",

    // ===== NOTES =====
    notePlaceholder: "Saisir une note de chantier...",
    addNoteBtn: "Ajouter note",
    noNotes: "Aucune note",
    noNotesHint: "Ajoutez votre première note de chantier",
    noteAdded: "Note ajoutée",
    noteDeleted: "Note supprimée",

    // ===== PHOTOS =====
    takePhotoBtn: "Prendre une photo ({count}/10)",
    noPhotos: "Aucune photo",
    noPhotosHint: "Prenez une photo depuis votre téléphone",
    maxPhotos: "Maximum 10 photos par chantier",
    photoAdded: "Photo ajoutée",
    photoDeleted: "Photo supprimée",
    uploading: "Chargement...",

    // ===== EQUIPE =====
    selectWorkers: "Sélectionnez les ouvriers assignés à ce chantier :",
    noOuvriers: "Aucun ouvrier inscrit",
    saveTeam: "Sauvegarder l'équipe ({count} ouvrier{s})",
    teamUpdated: "Équipe mise à jour",

    // ===== HISTORY =====
    noHistory: "Aucune activité enregistrée",
    historyHint: "L'historique des activités apparaîtra ici",
    actNote: "Note ajoutée",
    actPhoto: "Photo ajoutée",
    actPhotoDeleted: "Photo supprimée",
    actNoteDeleted: "Note supprimée",
    actTeam: "Équipe mise à jour",
    actUpdate: "Chantier mis à jour",
    actMaterial: "Matériau demandé",
    actCreated: "Chantier créé",

    // ===== CARD STATS =====
    photosLabel: "photo",
    notesLabel: "note",
    workersLabel: "ouvrier",

    // ===== MATERIAUX =====
    materiauxTitle: "Matériaux",
    materiauxSubtitle: "Gestion de votre inventaire",
    newMaterial: "Nouveau matériau",
    searchMaterial: "Rechercher un matériau...",
    noMaterial: "Aucun matériau",
    addFirstMaterial: "Commencez par ajouter votre premier matériau",
    addMaterial: "Ajouter un matériau",
    editMaterial: "Modifier le matériau",
    materialName: "Nom du matériau",
    category: "Catégorie",
    quantity: "Quantité",
    unit: "Unité",
    unitPrice: "Prix unitaire",
    alertThreshold: "Seuil d'alerte (stock minimum)",
    supplier: "Fournisseur",
    add: "Ajouter",
    stockValue: "Valeur stock",
    allCategories: "Toutes catégories",
    confirmDeleteMaterial: "Êtes-vous sûr de vouloir supprimer ce matériau ?",

    // ===== CATEGORIES =====
    wood: "Bois",
    steel: "Acier",
    concrete: "Béton",
    electricity: "Électricité",
    plumbing: "Plomberie",
    other: "Autre",

    // ===== UNITS =====
    kilograms: "Kilogrammes (kg)",
    meters: "Mètres (m)",
    squareMeters: "Mètres carrés (m²)",
    cubicMeters: "Mètres cubes (m³)",
    pieces: "Pièces",

    // ===== CALENDRIER =====
    calendarTitle: "Calendrier",
    calendarSubtitle: "Planification des tâches",
    newTask: "Nouvelle tâche",
    noChantierForTasks: "Créez d'abord un chantier pour ajouter des tâches",
    upcomingTasks: "Tâches à venir",
    noTasksPending: "Aucune tâche en attente",
    editTask: "Modifier la tâche",
    taskTitle: "Titre",
    selectChantier: "Sélectionner un chantier",
    priority: "Priorité",
    confirmDeleteTask: "Êtes-vous sûr de vouloir supprimer cette tâche ?",

    // ===== PRIORITIES =====
    low: "Basse",
    normal: "Normale",
    high: "Haute",
    urgent: "Urgente",

    // ===== TASK STATUS =====
    toDo: "À faire",

    // ===== ASSISTANT =====
    assistantTitle: "Assistant IA",
    assistantSubtitle: "Expert en estimation de matériaux et gestion de chantiers",
    clearHistory: "Effacer",
    assistantWelcome: "Assistant VGI Construct",
    assistantDescription: "Je suis votre assistant expert en construction. Posez-moi vos questions sur les estimations de matériaux, la planification de chantiers ou l'optimisation de vos projets.",
    askQuestion: "Posez votre question...",
    pressEnterToSend: "Appuyez sur Entrée pour envoyer, Maj+Entrée pour un retour à la ligne",
    confirmClearHistory: "Êtes-vous sûr de vouloir effacer l'historique ?",
    historyCleared: "Historique effacé",
    suggestion1: "Estime les matériaux pour une maison de 100m²",
    suggestion2: "Quels matériaux commander pour une dalle béton ?",
    suggestion3: "Conseils pour optimiser mon budget chantier",

    // ===== DEMANDES MATERIAUX =====
    demandesTitle: "Demandes Matériaux",
    demandesSubtitle: "Liste des matériaux nécessaires par chantier",
    tomorrowTitle: "Matériaux pour demain",
    newRequest: "Nouvelle demande",
    noRequest: "Aucune demande",
    addFirstRequest: "Les ouvriers peuvent demander des matériaux ici",
    selectSite: "Chantier",
    dateNeeded: "Date besoin",
    material: "Matériau",
    quantityField: "Quantité",
    unitField: "Unité",
    urgency: "Urgence",
    normalUrgency: "Normale",
    urgentUrgency: "Urgente",
    notesField: "Notes",
    submitRequest: "Demander",
    requestedBy: "Demandé par",
    statusPending: "En attente",
    statusApproved: "Approuvé",
    statusRefused: "Refusé",
    statusDelivered: "Livré",
    approveBtn: "Approuver",
    refuseBtn: "Refuser",
    markDeliveredBtn: "Marquer livré",
    noMaterialsTomorrow: "Aucun matériau à préparer pour demain",
    requestSent: "Demande envoyée",

    // ===== NOTES CHANTIER =====
    notesChantierTitle: "Notes Chantier",
    notesChantierSubtitle: "Notes à traiter — suppléments, devis, matériel",
    addNoteChantier: "Ajouter une note chantier",
    notesATraiter: "Notes à traiter",
    noteType: "Type de note",
    typeSupplementLabel: "Supplément",
    typeDevisLabel: "Devis",
    typeMaterielLabel: "Matériel à commander",
    typeRemarqueLabel: "Remarque client",
    montantEstime: "Montant estimé (€)",
    montantOptional: "optionnel",
    addToDevis: "Ajouter au devis",
    markDone: "Marquer comme traité",
    noteCreated: "Note ajoutée",
    noteMarkedDone: "Note marquée comme traitée",
    noteAddedToDevis: "Ajouté au devis",
    noNotesToProcess: "Aucune note à traiter",
    noNotesHintChantier: "Ajoutez des notes depuis la page Chantiers",
    statusATraiter: "À traiter",
    statusTraite: "Traité",
    statusAjouteDevis: "Ajouté au devis",
    filterAll: "Toutes",
    filterATraiter: "À traiter",
    filterDevis: "Au devis",
    filterTraite: "Traités",
    photoOptional: "Photo (optionnelle)",
    totalAmount: "Total estimé",

    // ===== GALERIE =====
    tabGalerie: "Galerie",
    galerieTous: "Tout",
    galerieAvant: "Avant",
    galeriePendant: "Pendant",
    galerieApres: "Après",
    galerieCategorie: "Catégorie",
    galerieLegende: "Légende",
    galerieLegendePlaceholder: "Ex: Pose du carrelage...",
    galerieUploadBtn: "Ajouter photo ou vidéo",
    galeriePhotoAdded: "Photo ajoutée",
    galerieVideoAdded: "Vidéo ajoutée",
    galerieMediaDeleted: "Supprimé",
    galerieLegendeSaved: "Légende enregistrée",
    galerieVideoTooLarge: "Vidéo trop grande (max 50 Mo)",
    galerieEmpty: "Aucun média",
    galerieEmptyHint: "Ajoutez vos premières photos ou vidéos",
    galeriePubliqueActive: "Galerie publique activée",
    galeriePubliqueOff: "Galerie privée",
    galeriePublished: "Galerie publiée !",
    galerieUnpublished: "Galerie rendue privée",
    galerieEmbedCode: "Code d'intégration",
    galerieEmbedHint: "Copiez ce code et collez-le dans votre site vgiconstruct.be",
    galerieNoLegende: "Aucune légende",
    copyEmbedCode: "Copier le code",
    copy: "Copier",
    copied: "Copié !",

    // ===== EQUIPE MANAGEMENT =====
    equipeTitle: "Équipe",
    newOuvrier: "Nouvel ouvrier",
    editOuvrier: "Modifier l'ouvrier",
    ouvrierCreated: "Compte ouvrier créé",
    ouvrierUpdated: "Compte mis à jour",
    ouvrierDeleted: "Ouvrier supprimé",
    confirmDeleteOuvrier: "Supprimer cet ouvrier ? Il sera retiré de tous les chantiers.",
    noOuvriersYet: "Aucun ouvrier",
    addFirstOuvrier: "Ajoutez votre premier ouvrier",
    searchOuvrier: "Rechercher un ouvrier...",
    newPasswordHint: "Nouveau mot de passe (laisser vide pour ne pas changer)",
    memberSince: "Membre depuis",
    passwordField: "Mot de passe",

    // ===== LOGIN PAGE =====
    welcomeTitle: "Bienvenue",
    loginSubtitle: "Connectez-vous à VGI Construct",
    loginBtn: "Se connecter",
    registerBtn: "Créer un compte",
    noAccountQ: "Pas de compte ?",
    hasAccountQ: "Déjà un compte ?",
    createAccountLink: "Créer un compte",
    loginHereLink: "Se connecter",
    loginSuccess: "Connexion réussie",
    registerSuccess: "Compte créé avec succès",
    firstName: "Prénom",
    lastName: "Nom",
    emailField: "Email",
    role: "Rôle",
    patronRole: "Patron",
    ouvrierRole: "Ouvrier",

    // ===== QUICK ACTIONS FAB =====
    quickActions: "Actions rapides",
    newChantierAction: "Nouveau chantier",
    addPhotoAction: "Ajouter une photo",
    newRequestAction: "Demander du matériel",
    uploading: "Chargement...",
    siteUpdated: "Chantier mis à jour",
    siteDeleted: "Chantier supprimé",
    errorGeneric: "Une erreur est survenue",
    errorLoading: "Erreur lors du chargement",
    errorSaving: "Erreur lors de l'enregistrement",

    // ===== DAYS =====
    mon: "Lun", tue: "Mar", wed: "Mer", thu: "Jeu", fri: "Ven", sat: "Sam", sun: "Dim",

    // ===== MONTHS =====
    january: "Janvier", february: "Février", march: "Mars", april: "Avril",
    may: "Mai", june: "Juin", july: "Juillet", august: "Août",
    september: "Septembre", october: "Octobre", november: "Novembre", december: "Décembre",

    // ===== MOBILE NAV =====
    home: "Accueil",
    planning: "Planning",
    ia: "IA",

    // ===== COMMON =====
    actions: "Actions",
    save: "Enregistrer",
    delete: "Supprimer",
    edit: "Modifier",
    close: "Fermer",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    confirm: "Confirmer",
    by: "par",
  },

  ro: {
    // ===== NAVIGATION =====
    dashboard: "Tablou de bord",
    chantiers: "Șantiere",
    materiaux: "Materiale",
    calendrier: "Calendar",
    assistant: "Asistent IA",
    rdv: "Întâlniri",
    demandes: "Cereri materiale",
    language: "Limbă",
    logout: "Deconectare",

    // ===== DASHBOARD =====
    dashboardTitle: "Tablou de Bord",
    dashboardSubtitle: "Vedere de ansamblu a șantierelor și resurselor",
    activeChantiers: "Șantiere active",
    onTotal: "din {0} total",
    materialsInStock: "Materiale în stoc",
    typesReferenced: "tipuri referențiate",
    urgentTasks: "Sarcini urgente",
    toProcess: "de procesat",
    totalBudget: "Buget total",
    allChantiers: "toate șantierele",
    recentChantiers: "Șantiere recente",
    stockAlerts: "Alerte stoc",
    noChantierRegistered: "Niciun șantier înregistrat",
    allStocksOk: "Toate stocurile sunt OK",
    progression: "Progres",
    stock: "Stoc",
    threshold: "prag",
    todaySection: "Astăzi",
    activeSites: "Șantiere active",
    rdvToday: "Întâlniri viitoare",
    materialsTomorrow: "Materiale mâine",
    pendingRequests: "Cereri în așteptare",
    remindersBanner: "Remindere de azi",
    rdvTodayLabel: "Întâlniri astăzi",
    rdvTomorrowLabel: "Întâlniri mâine",
    materialsToPrepare: "materiale de pregătit",
    deadlineSoon: "termen apropiat",
    allReady: "Totul este pregătit!",
    stockOK: "Niveluri suficiente",
    nextRDV: "Următoarele întâlniri",
    planBtn: "Planificați",
    noRDV: "Nicio întâlnire viitoare",
    recentSites: "Șantiere recente",
    seeAll: "Vezi tot",
    createFirst: "Creați primul",
    matsDemain: "Materiale mâine",
    actifs: "Active",
    urgences: "Urgențe",
    budgetStat: "Buget",
    greetingMorning: "Bună dimineața",
    greetingAfternoon: "Bună ziua",
    greetingEvening: "Bună seara",

    // ===== CHANTIERS =====
    chantiersTitle: "Șantiere",
    chantiersSubtitle: "Gestionați proiectele de construcție",
    newChantier: "Șantier nou",
    searchChantier: "Căutați un șantier...",
    noChantier: "Niciun șantier",
    noAssignedChantier: "Niciun șantier atribuit",
    createFirstChantier: "Începeți prin a crea primul șantier",
    createChantier: "Creați un șantier",
    editChantier: "Modificați șantierul",
    chantierName: "Numele șantierului",
    address: "Adresă",
    client: "Client",
    startDate: "Data începerii",
    expectedEndDate: "Data finalizării prevăzute",
    status: "Stare",
    budget: "Buget",
    description: "Descriere",
    cancel: "Anulare",
    create: "Creați",
    update: "Actualizați",
    inProgress: "În curs",
    paused: "În pauză",
    completed: "Finalizat",
    confirmDeleteChantier: "Sigur doriți să ștergeți acest șantier?",
    viewDetails: "Vezi detalii",
    chantierCount: "{0} șantier",
    chantiersCount: "{0} șantiere",
    assignedLabel: "atribuite",
    totalLabel: "total",

    // ===== CHANTIER DETAIL TABS =====
    tabInfos: "Informații",
    tabNotes: "Note",
    tabPhotos: "Fotografii",
    tabEquipe: "Echipă",
    tabHistory: "Istoric",

    // ===== CHANTIER DETAIL INFOS =====
    chantierClient: "Client",
    chantierBudget: "Buget",
    chantierAddress: "Adresă",
    chantierStart: "Început",
    chantierEnd: "Finalizare prevăzută",
    chantierProgress: "Progres",

    // ===== NOTES =====
    notePlaceholder: "Introduceți o notă...",
    addNoteBtn: "Adăugați notă",
    noNotes: "Nicio notă",
    noNotesHint: "Adăugați prima notă a șantierului",
    noteAdded: "Notă adăugată",
    noteDeleted: "Notă ștearsă",

    // ===== PHOTOS =====
    takePhotoBtn: "Faceți o fotografie ({count}/10)",
    noPhotos: "Nicio fotografie",
    noPhotosHint: "Faceți o fotografie de pe telefon",
    maxPhotos: "Maximum 10 fotografii pe șantier",
    photoAdded: "Fotografie adăugată",
    photoDeleted: "Fotografie ștearsă",
    uploading: "Se încarcă...",

    // ===== EQUIPE =====
    selectWorkers: "Selectați muncitorii atribuiți acestui șantier:",
    noOuvriers: "Niciun muncitor înregistrat",
    saveTeam: "Salvați echipa ({count} muncitor{s})",
    teamUpdated: "Echipă actualizată",

    // ===== HISTORY =====
    noHistory: "Nicio activitate înregistrată",
    historyHint: "Istoricul activităților va apărea aici",
    actNote: "Notă adăugată",
    actPhoto: "Fotografie adăugată",
    actPhotoDeleted: "Fotografie ștearsă",
    actNoteDeleted: "Notă ștearsă",
    actTeam: "Echipă actualizată",
    actUpdate: "Șantier actualizat",
    actMaterial: "Material solicitat",
    actCreated: "Șantier creat",

    // ===== CARD STATS =====
    photosLabel: "fotografie",
    notesLabel: "notă",
    workersLabel: "muncitor",

    // ===== MATERIAUX =====
    materiauxTitle: "Materiale",
    materiauxSubtitle: "Gestionarea inventarului",
    newMaterial: "Material nou",
    searchMaterial: "Căutați un material...",
    noMaterial: "Niciun material",
    addFirstMaterial: "Începeți prin a adăuga primul material",
    addMaterial: "Adăugați un material",
    editMaterial: "Modificați materialul",
    materialName: "Numele materialului",
    category: "Categorie",
    quantity: "Cantitate",
    unit: "Unitate",
    unitPrice: "Preț unitar",
    alertThreshold: "Prag de alertă (stoc minim)",
    supplier: "Furnizor",
    add: "Adăugați",
    stockValue: "Valoare stoc",
    allCategories: "Toate categoriile",
    confirmDeleteMaterial: "Sigur doriți să ștergeți acest material?",

    // ===== CATEGORIES =====
    wood: "Lemn",
    steel: "Oțel",
    concrete: "Beton",
    electricity: "Electricitate",
    plumbing: "Instalații sanitare",
    other: "Altele",

    // ===== UNITS =====
    kilograms: "Kilograme (kg)",
    meters: "Metri (m)",
    squareMeters: "Metri pătrați (m²)",
    cubicMeters: "Metri cubi (m³)",
    pieces: "Bucăți",

    // ===== CALENDRIER =====
    calendarTitle: "Calendar",
    calendarSubtitle: "Planificarea sarcinilor",
    newTask: "Sarcină nouă",
    noChantierForTasks: "Creați mai întâi un șantier pentru a adăuga sarcini",
    upcomingTasks: "Sarcini viitoare",
    noTasksPending: "Nicio sarcină în așteptare",
    editTask: "Modificați sarcina",
    taskTitle: "Titlu",
    selectChantier: "Selectați un șantier",
    priority: "Prioritate",
    confirmDeleteTask: "Sigur doriți să ștergeți această sarcină?",

    // ===== PRIORITIES =====
    low: "Scăzută",
    normal: "Normală",
    high: "Ridicată",
    urgent: "Urgentă",

    // ===== TASK STATUS =====
    toDo: "De făcut",

    // ===== ASSISTANT =====
    assistantTitle: "Asistent IA",
    assistantSubtitle: "Expert în estimarea materialelor și gestionarea șantierelor",
    clearHistory: "Ștergeți",
    assistantWelcome: "Asistent VGI Construct",
    assistantDescription: "Sunt asistentul dvs. expert în construcții. Puneți-mi întrebări despre estimările de materiale, planificarea șantierelor sau optimizarea proiectelor.",
    askQuestion: "Puneți întrebarea...",
    pressEnterToSend: "Apăsați Enter pentru a trimite, Shift+Enter pentru linie nouă",
    confirmClearHistory: "Sigur doriți să ștergeți istoricul?",
    historyCleared: "Istoric șters",
    suggestion1: "Estimează materialele pentru o casă de 100m²",
    suggestion2: "Ce materiale să comand pentru o placă de beton?",
    suggestion3: "Sfaturi pentru optimizarea bugetului șantierului",

    // ===== DEMANDES MATERIAUX =====
    demandesTitle: "Cereri Materiale",
    demandesSubtitle: "Lista materialelor necesare pe șantier",
    tomorrowTitle: "Materiale pentru mâine",
    newRequest: "Cerere nouă",
    noRequest: "Nicio cerere",
    addFirstRequest: "Muncitorii pot solicita materiale aici",
    selectSite: "Șantier",
    dateNeeded: "Data necesară",
    material: "Material",
    quantityField: "Cantitate",
    unitField: "Unitate",
    urgency: "Urgență",
    normalUrgency: "Normală",
    urgentUrgency: "Urgentă",
    notesField: "Note",
    submitRequest: "Solicită",
    requestedBy: "Solicitat de",
    statusPending: "În așteptare",
    statusApproved: "Aprobat",
    statusRefused: "Refuzat",
    statusDelivered: "Livrat",
    approveBtn: "Aprobă",
    refuseBtn: "Refuză",
    markDeliveredBtn: "Marchează livrat",
    noMaterialsTomorrow: "Niciun material de pregătit pentru mâine",
    requestSent: "Cerere trimisă",

    // ===== NOTES CHANTIER =====
    notesChantierTitle: "Note Șantier",
    notesChantierSubtitle: "Note de tratat — suplimente, devize, materiale",
    addNoteChantier: "Adăugați o notă",
    notesATraiter: "Note de tratat",
    noteType: "Tipul notei",
    typeSupplementLabel: "Supliment",
    typeDevisLabel: "Deviz",
    typeMaterielLabel: "Material de comandat",
    typeRemarqueLabel: "Observație client",
    montantEstime: "Sumă estimată (€)",
    montantOptional: "opțional",
    addToDevis: "Adăugați la deviz",
    markDone: "Marcați ca tratat",
    noteCreated: "Notă adăugată",
    noteMarkedDone: "Notă marcată ca tratată",
    noteAddedToDevis: "Adăugat la deviz",
    noNotesToProcess: "Nicio notă de tratat",
    noNotesHintChantier: "Adăugați note din pagina Șantiere",
    statusATraiter: "De tratat",
    statusTraite: "Tratat",
    statusAjouteDevis: "Adăugat la deviz",
    filterAll: "Toate",
    filterATraiter: "De tratat",
    filterDevis: "La deviz",
    filterTraite: "Tratate",
    photoOptional: "Fotografie (opțională)",
    totalAmount: "Total estimat",

    // ===== GALERIE =====
    tabGalerie: "Galerie",
    galerieTous: "Toate",
    galerieAvant: "Înainte",
    galeriePendant: "În cursul",
    galerieApres: "După",
    galerieCategorie: "Categorie",
    galerieLegende: "Legendă",
    galerieLegendePlaceholder: "Ex: Montaj gresie...",
    galerieUploadBtn: "Adaugă foto sau video",
    galeriePhotoAdded: "Fotografie adăugată",
    galerieVideoAdded: "Video adăugat",
    galerieMediaDeleted: "Șters",
    galerieLegendeSaved: "Legendă salvată",
    galerieVideoTooLarge: "Video prea mare (max 50 MB)",
    galerieEmpty: "Niciun conținut media",
    galerieEmptyHint: "Adăugați primele fotografii sau videoclipuri",
    galeriePubliqueActive: "Galerie publică activată",
    galeriePubliqueOff: "Galerie privată",
    galeriePublished: "Galerie publicată!",
    galerieUnpublished: "Galerie privatizată",
    galerieEmbedCode: "Cod de integrare",
    galerieEmbedHint: "Copiați acest cod și inserați-l în site-ul dvs.",
    galerieNoLegende: "Fără legendă",
    copyEmbedCode: "Copiați codul",
    copy: "Copiați",
    copied: "Copiat!",

    // ===== EQUIPE MANAGEMENT =====
    equipeTitle: "Echipă",
    newOuvrier: "Muncitor nou",
    editOuvrier: "Modificați muncitorul",
    ouvrierCreated: "Cont muncitor creat",
    ouvrierUpdated: "Cont actualizat",
    ouvrierDeleted: "Muncitor șters",
    confirmDeleteOuvrier: "Ștergeți acest muncitor? Va fi eliminat din toate șantierele.",
    noOuvriersYet: "Niciun muncitor",
    addFirstOuvrier: "Adăugați primul muncitor",
    searchOuvrier: "Căutați un muncitor...",
    newPasswordHint: "Parolă nouă (lăsați gol pentru a nu schimba)",
    memberSince: "Membru din",
    passwordField: "Parolă",

    // ===== LOGIN PAGE =====
    welcomeTitle: "Bine ați venit",
    loginSubtitle: "Conectați-vă la VGI Construct",
    loginBtn: "Conectare",
    registerBtn: "Creați cont",
    noAccountQ: "Nu aveți cont?",
    hasAccountQ: "Aveți deja cont?",
    createAccountLink: "Creați cont",
    loginHereLink: "Conectați-vă",
    loginSuccess: "Conectare reușită",
    registerSuccess: "Cont creat cu succes",
    firstName: "Prenume",
    lastName: "Nume",
    emailField: "Email",
    role: "Rol",
    patronRole: "Patron",
    ouvrierRole: "Muncitor",

    // ===== QUICK ACTIONS FAB =====
    quickActions: "Acțiuni rapide",
    newChantierAction: "Șantier nou",
    addPhotoAction: "Adaugă fotografie",
    addNoteAction: "Adaugă notă",
    newRequestAction: "Solicită material",

    // ===== NOTIFICATIONS =====
    siteCreated: "Șantier creat cu succes",
    siteUpdated: "Șantier actualizat",
    siteDeleted: "Șantier șters",
    errorGeneric: "A apărut o eroare",
    errorLoading: "Eroare la încărcare",
    errorSaving: "Eroare la salvare",

    // ===== DAYS =====
    mon: "Lun", tue: "Mar", wed: "Mie", thu: "Joi", fri: "Vin", sat: "Sâm", sun: "Dum",

    // ===== MONTHS =====
    january: "Ianuarie", february: "Februarie", march: "Martie", april: "Aprilie",
    may: "Mai", june: "Iunie", july: "Iulie", august: "August",
    september: "Septembrie", october: "Octombrie", november: "Noiembrie", december: "Decembrie",

    // ===== MOBILE NAV =====
    home: "Acasă",
    planning: "Planificare",
    ia: "IA",

    // ===== COMMON =====
    actions: "Acțiuni",
    save: "Salvați",
    delete: "Ștergeți",
    edit: "Modificați",
    close: "Închideți",
    loading: "Se încarcă...",
    error: "Eroare",
    success: "Succes",
    confirm: "Confirmați",
    by: "de",
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('vgi-language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('vgi-language', language);
  }, [language]);

  const t = (key, ...args) => {
    let text = translations[language][key] || translations['fr'][key] || key;
    args.forEach((arg, index) => {
      text = text.replace(`{${index}}`, arg);
    });
    return text;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'ro' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default translations;
